import React, { Component } from 'react';
import { Row, Col, Table, Panel, PanelGroup } from "react-bootstrap";
import { CustomCard } from "../../components/Card/CustomCard";

import { consultaEst } from "../../funciones/CambioCarrFunction";
import { NotActiacion, ConsultaAcademicosEst } from '../../funciones/RendAcadFunction';
import { ConsultaDeuda } from '../../funciones/EstCuentaFunction';

import MensajeRetraso from "../../shared/MensajeRetraso";

let deudaTRendAc = "";

class RendimientoAcademico extends Component {
    state = {
        est: {
            ci: "Cargando",
            name: "Cargando",
        },
        carrera: {carrera_name: "Cargando"},
        cortes: 0,
        p_c1: 0,
        p_c2: 0,
        p_c3: 0,
        p_c4: 0,
        p_c5: 0,
        control: false,

        carreras: [],
        materias: [],
        materiashHist: [],
        semestres: [],
        textCarreras: <React.Fragment><i className ="fa fa-spinner fa-spin"></i> Buscando las carreras, espera</React.Fragment>,
        iconChevron: "fa fa-chevron-down",
        btnDown: true,
        preloadermat:  <React.Fragment><i className ="fa fa-spinner fa-spin"></i> Buscando materias</React.Fragment>,
    }

    constructor (props) {
        super (props);

        consultaEst((resp) => {
            /* statusEst = resp[1]; */
            let nombre2 = resp[0].nombre_2;
            let apellido2 = resp[0].apellido_2;
            if (nombre2 === null) nombre2 = "";
            if (apellido2 === null) apellido2 = "";

            ConsultaAcademicosEst(resp[0].id, (respData) => {
                this.setState({
                    carreras: respData[0],
                    materiashHist: respData[1],
                    semestres: respData[2],
    
                    est:{
                        ci:`${resp[0].nacionalidad} ${resp[0].ci}`,
                        name: `${resp[0].nombre_1} ${nombre2} ${resp[0].apellido_1} ${apellido2}`
                    },
                    carrera: resp[4],
                    cortes: resp[7].cortes,
                    p_c1: resp[7].p_corte_1,
                    p_c2: resp[7].p_corte_2,
                    p_c3: resp[7].p_corte_3,
                    p_c4: resp[7].p_corte_4,
                    p_c5: resp[7].p_corte_5,
                })
            })
        })

        NotActiacion ((resp) => {
            let preloader = ""
            if (resp.length === 0) preloader = "No estas inscrito"
            this.setState({
                materias: resp,
                preloadermat: preloader
            })
        })
    }

    componentDidMount = () => {
        ConsultaDeuda ((resp) => {
            deudaTRendAc = resp.deudaVencida
            this.setState({deudaT: resp.deudaVencida})
        })
    }
    /* cambiaPanel = (activeKey) => {
        this.setState({ activeKey });
    } */

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown,
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    carreras = () => {
        let { carreras, textCarreras, iconChevron } = this.state;
        const styles = {
            padding: 5, fontSize: 10
        }

        if (carreras.length === 0) return (
            <div align="center" className="custom-color custom-mt-10">{textCarreras}</div>
        )

        let materiasE = (idCarrera) => {
            let { materiashHist, semestres } = this.state;
            let SemContent = [];

            let enLetras= (nota) => {
                let letras = [
                    "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                    "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                    "DIECINUEVE", "VEINTE"
                ];

                return letras[nota - 1]
            }

            let mes = (num) => {
                let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
                
                return meses[num - 1]
            }

            let literal = (nota) => {
                if (nota === "1") return "APROBADO";
                return "REPROBADO"
            }

            let nota = (nota, tipo) => {
                if (tipo === 1) return (
                    <React.Fragment>
                        <td align="center" style={styles}>{nota}</td>
                        <td align="center" style={styles}>{enLetras(nota)}</td>
                    </React.Fragment>
                )

                if (nota === "" || nota === "0") return (
                    <td align="center" colSpan={2} style={styles}></td>
                )

                return (
                    <td align="center" colSpan= {2} style={styles}>{literal(nota)}</td>
                )
            }

            let materiasSem = (sem) => {
                let materiasContent = [];

                for (let i in materiashHist) {
                    if (idCarrera === materiashHist[i].carrera_id && sem === materiashHist[i].semestre_num) materiasContent.push (
                        <tr key={materiashHist[i].id}>
                            <td align="center" style={{padding: 5, fontSize: 8}}>{materiashHist[i].codigo}</td>
                            <td style={styles}>{materiashHist[i].materia_name}</td>
                            <td align="center" style={styles}>{`${mes(materiashHist[i].corte_name)} ${materiashHist[i].corte_year}`}</td>
                            <td align="center" style={styles}>{materiashHist[i].tipoev_name}</td>
                            {nota(materiashHist[i].nota, materiashHist[i].cuantitativo)}
                        </tr>
                    )
                }

                return materiasContent;
            }

            for (let i in semestres) {
                if (idCarrera === semestres[i].carrera_id) SemContent.push (
                    <div key={i} className="custom-sem-historico">
                        <div style={{padding: 5}}>
                            <Row>
                                <Col md={12} style={{paddingTop:10, paddingLeft: 20}}>
                                    <strong style={{marginTop:5}} className="text-danger">{semestres[i].semestre_name}</strong>
                                </Col>
                            </Row>
                        </div>
                        <div className="custom-mt-10">
                            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td align="center" width="10%" style={styles}><strong>CÓDIGO</strong></td>
                                            <td width="45%" style={styles}><strong>MATERIA</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>PERIODO</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>T-E</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>NOTA</strong></td>
                                            <td align="center" width="15%" style={styles}><strong>LETRAS</strong></td>
                                        </tr>
                                        {materiasSem(semestres[i].semestre_num)}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                )
            }

            if (semestres.length === 0) return (<div align="center">No existen periodos registrados en esta carrera</div>)

            return SemContent;
        }

        let carrerasList = () => (
            carreras.map(option => (
                <Panel eventKey={option.id} key ={option.id} style={{marginBottom:5, marginTop: 5}}>
                    <Panel.Heading>
                        <Panel.Title toggle className="custom-color" onClick={this.cambiaIcon}>
                            <Row>
                                <Col md={10} style={{fontSize: 12}}>
                                    <strong>{option.carrera_name}</strong>
                                    <spam style={{fontSize: 10}}> (Haz click aqui para ver)</spam>
                                </Col>
                                <Col md={2} align="right">
                                    <i className={iconChevron}></i>
                                </Col>
                            </Row>
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                        {materiasE(option.id)}
                    </Panel.Body>
                </Panel>
            ))
        )

        return (
            <PanelGroup accordion activeKey={this.state.activeKey} className="custom-alert-info" id="semestres">
                {carrerasList()}
            </PanelGroup>
        )
    }

    contenido = () => {
        let { est, carrera, materias, cortes } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }


        let porcentajeCorte = (n) => {
            let porcentaje = ""
            if (n === 0) porcentaje = this.state.p_c1;
            if (n === 1) porcentaje = this.state.p_c2;
            if (n === 2) porcentaje = this.state.p_c3;
            if (n === 3) porcentaje = this.state.p_c4;
            if (n === 4) porcentaje = this.state.p_c5;

            return porcentaje;
        }

        let cortesN = () => {
            let contenido= []
            
            for (let i = 0; i < cortes; i++){
                let titulo = porcentajeCorte(i)
                contenido.push({
                    id: i,
                    titulo: titulo
                })
            }

            let porcentaje = 50;
            if (parseInt(cortes) !== 0) porcentaje =  50 / parseInt(cortes)
            return(
                contenido.map(option => (
                    <React.Fragment key={option.id}>
                        <td align="center" width={`${(porcentaje) / 2}%`} style={styles}><strong>Nota</strong></td>
                        <td align="center" width={`${(porcentaje) / 2}%`} style={styles}><strong>{option.titulo}%</strong></td>
                    </React.Fragment>
                ))
            )
        }
        
        let notaCorte = (data) => {
            let contenido= []
            
            for (let i = 0; i < cortes; i++){
                let porcentaje = ""
                if (i === 0) porcentaje = this.state.p_c1;
                if (i === 1) porcentaje = this.state.p_c2;
                if (i === 2) porcentaje = this.state.p_c3;
                if (i === 3) porcentaje = this.state.p_c4;
                if (i === 4) porcentaje = this.state.p_c5;

                let notaP = 0;

                notaP = (data[i] * porcentaje)/100;

                contenido.push({
                    id: `corte_${i + 1}`,
                    titulo: `Corte ${i + 1}`,
                    nota: data[i],
                    porcentaje: parseFloat(notaP).toFixed(2)
                })
            }

            let width = 50;
            if (parseInt(cortes) !== 0) width =  50 / parseInt(cortes)
            return(
                contenido.map(option => (
                    <React.Fragment key={option.id}>
                        <td title="Calificación obtenida" align="center" width={`${(width) / 2}%`} style={styles}>{option.nota}</td>
                        <td title="Conversion en cuanto al porcentaje" align="center" width={`${(width) / 2}%`} style={styles}>{option.porcentaje}</td>
                    </React.Fragment>
                ))
            )
        }

        let definitiva= (data) => {
            let notaP = 0;
            for (let i = 0; i < cortes; i++){
                let porcentaje = ""
                if (i === 0) porcentaje = this.state.p_c1;
                if (i === 1) porcentaje = this.state.p_c2;
                if (i === 2) porcentaje = this.state.p_c3;
                if (i === 3) porcentaje = this.state.p_c4;
                if (i === 4) porcentaje = this.state.p_c5;

                notaP += (data[i] * porcentaje)/100;
            }

            return Math.round(notaP);
        }

        let contenidoInsc = () => {
            
            if (materias.length === 0) return (
                <tr>
                    <td colSpan={parseInt(cortes * 2) + 2} width="100%" align="center" style={styles}>
                        {this.state.preloadermat}
                    </td>
                    <td></td>
                </tr>
            )
            
            return(
                materias.map(option => (
                    <tr key={option.id}>
                        <td style={{fontSize:10, padding: 5}}>{option.materia}</td>
                        {notaCorte([option.corte1, option.corte2, option.corte3, option.corte4, option.corte5])}
                        <td title="Calificación Acumulada" style={{fontSize:12, padding: 5}} align="center"><strong>{definitiva([option.corte1, option.corte2, option.corte3, option.corte4, option.corte5])}</strong></td>
                    </tr>
                ))
            )
        }

        let detallesContenido = () => {
            if (deudaTRendAc === "") return (
                <Col md ={12} className="custom-mt-10">
                    <div className="text-danger" align = "center"><i className="fa fa-spinner fa-spin"></i> Buscando Información, espera</div>
                </Col>
            )

            if (deudaTRendAc > 0) return (
                <Col md ={12} className="custom-mt-10">
                    <MensajeRetraso />
                </Col>
            )

            return (
                <React.Fragment>
                    <Col md ={12} className="custom-mt-10">
                        <div className="custom-alert-warning custom-mt-10">Histórico de Mis Carreras</div>
                        <div className="custom-mt-10" style={{marginBottom: 20}}>
                            {this.carreras()}
                        </div>
                    </Col>
                    <Col md ={12}><div className="custom-alert-info" style={{padding:5}}>Mis Materias Inscritas</div></Col>
                    <Col md ={12} className="custom-mt-10">
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td rowSpan={2} width="40%" style={styles}><strong>Materias</strong></td>
                                        <td colSpan={parseInt(cortes * 2)} width="50%" align="center" style={styles}><strong>Cortes de Nota</strong></td>
                                        <td rowSpan={2} width="10%" align="center" style={styles}><strong>Def.</strong></td>
                                    </tr>
                                    <tr style={{backgroundColor:"#adcec9", color:"#000"}}>
                                        {cortesN()}
                                    </tr>
                                    {contenidoInsc()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>
                </React.Fragment>
            )
        }

        return (
            <React.Fragment>
                <Row>
                    <Col md ={12}><div className="custom-alert-info" style={{padding:5}}>Mis Datos</div></Col>
                    <Col md ={2} className="custom-mt-10" style={{fontSize: 10}}>
                        <div className="text-danger">Cédula</div>
                        <div>{est.ci}</div>
                    </Col>
                    <Col md ={7} className="custom-mt-10" style={{fontSize: 10}}>
                        <div className="text-danger">Nombre</div>
                        <div>{est.name}</div>
                    </Col>
                    <Col md ={3} className="custom-mt-10" style={{fontSize: 10}}>
                        <div className="text-danger">Carrera Actual</div>
                        <div>{carrera.carrera_name}</div>
                    </Col>
                    {detallesContenido()}
                </Row>
            </React.Fragment>
        )
    }

    ayuda= () => {
        return(
            <Row>
                <Col md={12}><strong style={{color:"#1f2f6e"}}>Datos Históricos</strong></Col>
                <Col md={12} align="justify">
                    Para ver tu rendimiento haz click en el recuadro que dice <strong style={{color:"#1f2f6e"}}>Datos Históricos <span style={{fontSize:10}}>(Haz click aqui para ver)</span></strong> y podrás tener detalladamente la información de periodos anteriores
                </Col>
                <Col md={12} className="custom-mt-10" align="justify" style={{color:"#1f2f6e"}}><strong>Mis Materias Inscritas</strong></Col>
                <Col md={12} align="justify">
                    Esta opción te permite ver el avance durante el periodo académico actual en los distintos cortes evaluados.
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    Cada corte de notas contiene:
                </Col>
                <Col md={12} align="justify" style={{paddingLeft:25}}>
                    <strong style={{color:"#1f2f6e"}}>Nota:</strong> aqui puedes ver la calificación obtenida en el corte de notas
                </Col>
                <Col md={12} align="justify" style={{paddingLeft:25}}>
                    <strong style={{color:"#1f2f6e"}}>Porcentaje (%):</strong> corresponde a la conversión derivada de la calificación obtenida en el corte de notas correspondiente al porcentaje indicado en el encabezado.
                </Col>
                <Col md={12} className="custom-mt-10" align="justify">
                    <strong style={{color:"#1f2f6e"}}>Def. (Definitiva)</strong>
                </Col>
                <Col md={12} align="justify">
                    Representa el total acumulado durante el periodo académico.
                </Col>
            </Row>
        )
    }

    render() { 
        return (
            <React.Fragment>
                <div className="content">
                    <Row>
                        <Col md={8}>
                            <Row>
                                <Col md={12}>{this.contenido()}</Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div style={{borderRadius: "4px 4px",}}>
                                <CustomCard
                                    styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                    title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                    category={<span style={{color: "#fff"}}>Rendimiento Académico</span>}
                                    color="#a80012"
                                    content={this.ayuda()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        );
    }
}
 
export default RendimientoAcademico;


// WEBPACK FOOTER //
// ./src/views/EstConsultas/RendimientoAcademico.jsx